// Generated by scripts/import-seo-content.js — do not edit by hand.
// Regenerate with: node scripts/import-seo-content.js

export type SeoPageEntry = {
  /** Public Swedish URL. */
  url: string
  /** Short label for navigation, e.g. "Dodge Ram" rather than "Däck till Dodge Ram". */
  navLabel: string
  /** True for the three category roots, which are search pages carrying SEO copy. */
  isRoot?: boolean
}

export const seoPages: SeoPageEntry[] = [
  {
    url: '/vara-varumarken',
    navLabel: 'Våra varumärken',
  },
  {
    url: '/vara-varumarken/dirt-at-wheels',
    navLabel: 'Dirt A.T Wheels',
  },
  {
    url: '/vara-varumarken/boost-wheels',
    navLabel: 'Boost Wheels',
  },
  {
    url: '/vara-varumarken/blackbear',
    navLabel: 'Blackbear',
  },
  {
    url: '/vara-varumarken/ridgeblade',
    navLabel: 'Ridgeblade',
  },
  {
    url: '/dack',
    navLabel: 'Däck',
    isRoot: true,
  },
  {
    url: '/dack/sommardack',
    navLabel: 'Sommardäck',
  },
  {
    url: '/dack/vinterdack',
    navLabel: 'Vinterdäck',
  },
  {
    url: '/dack/pickup',
    navLabel: 'Pickup',
  },
  {
    url: '/dack/pickup/dodge-ram',
    navLabel: 'Dodge Ram',
  },
  {
    url: '/dack/pickup/chevrolet-silverado',
    navLabel: 'Chevrolet Silverado',
  },
  {
    url: '/dack/pickup/ford-f-150',
    navLabel: 'Ford F-150',
  },
  {
    url: '/dack/pickup/ram-1500',
    navLabel: 'Ram 1500',
  },
  {
    url: '/dack/pickup/ford-ranger',
    navLabel: 'Ford Ranger',
  },
  {
    url: '/dack/pickup/gmc-sierra',
    navLabel: 'GMC Sierra',
  },
  {
    url: '/dack/pickup/ram-rampage',
    navLabel: 'Ram Rampage',
  },
  {
    url: '/dack/transportbil',
    navLabel: 'Transportbil',
  },
  {
    url: '/dack/transportbil/mercedes-sprinter',
    navLabel: 'Mercedes Sprinter',
  },
  {
    url: '/dack/transportbil/volkswagen-transporter',
    navLabel: 'Volkswagen Transporter',
  },
  {
    url: '/dack/transportbil/ford-transit-custom',
    navLabel: 'Ford Transit Custom',
  },
  {
    url: '/dack/transportbil/volkswagen-caddy',
    navLabel: 'Volkswagen Caddy',
  },
  {
    url: '/dack/transportbil/fiat-ducato',
    navLabel: 'Fiat Ducato',
  },
  {
    url: '/dack/transportbil/campervan',
    navLabel: 'Campervan',
  },
  {
    url: '/dack/transportbil/overlanding',
    navLabel: 'Overlanding',
  },
  {
    url: '/dack/personbil',
    navLabel: 'Personbil',
  },
  {
    url: '/dack/faq',
    navLabel: 'FAQ',
  },
  {
    url: '/falgar',
    navLabel: 'Fälgar',
    isRoot: true,
  },
  {
    url: '/falgar/pickup',
    navLabel: 'Pickup',
  },
  {
    url: '/falgar/pickup/dodge-ram',
    navLabel: 'Dodge Ram',
  },
  {
    url: '/falgar/pickup/ford-ranger',
    navLabel: 'Ford Ranger',
  },
  {
    url: '/falgar/pickup/chevrolet-silverado',
    navLabel: 'Chevrolet Silverado',
  },
  {
    url: '/falgar/pickup/ford-f-150',
    navLabel: 'Ford F-150',
  },
  {
    url: '/falgar/pickup/ram-1500',
    navLabel: 'Ram 1500',
  },
  {
    url: '/falgar/pickup/nissan-navara',
    navLabel: 'Nissan Navara',
  },
  {
    url: '/falgar/pickup/volkswagen-amarok',
    navLabel: 'Volkswagen Amarok',
  },
  {
    url: '/falgar/pickup/gmc-sierra',
    navLabel: 'GMC Sierra',
  },
  {
    url: '/falgar/pickup/ram-rampage',
    navLabel: 'Ram Rampage',
  },
  {
    url: '/falgar/transportbil',
    navLabel: 'Transportbil',
  },
  {
    url: '/falgar/transportbil/mercedes-sprinter',
    navLabel: 'Mercedes Sprinter',
  },
  {
    url: '/falgar/transportbil/volkswagen-transporter',
    navLabel: 'Volkswagen Transporter',
  },
  {
    url: '/falgar/transportbil/ford-transit-custom',
    navLabel: 'Ford Transit Custom',
  },
  {
    url: '/falgar/transportbil/volkswagen-caddy',
    navLabel: 'Volkswagen Caddy',
  },
  {
    url: '/falgar/transportbil/fiat-ducato',
    navLabel: 'Fiat Ducato',
  },
  {
    url: '/falgar/transportbil/campervan',
    navLabel: 'Campervan',
  },
  {
    url: '/falgar/transportbil/overlanding',
    navLabel: 'Overlanding',
  },
  {
    url: '/falgar/personbil',
    navLabel: 'Personbil',
  },
  {
    url: '/falgar/stalfalgar',
    navLabel: 'Stålfälgar',
  },
  {
    url: '/falgar/aluminiumfalgar',
    navLabel: 'Aluminiumfälgar',
  },
  {
    url: '/falgar/faq',
    navLabel: 'FAQ',
  },
  {
    url: '/kompletta-hjul',
    navLabel: 'Kompletta hjul',
    isRoot: true,
  },
  {
    url: '/kompletta-hjul/pickup',
    navLabel: 'Pickup',
  },
  {
    url: '/kompletta-hjul/pickup/dodge-ram',
    navLabel: 'Dodge Ram',
  },
  {
    url: '/kompletta-hjul/pickup/ford-ranger',
    navLabel: 'Ford Ranger',
  },
  {
    url: '/kompletta-hjul/pickup/chevrolet-silverado',
    navLabel: 'Chevrolet Silverado',
  },
  {
    url: '/kompletta-hjul/pickup/ford-f-150',
    navLabel: 'Ford F-150',
  },
  {
    url: '/kompletta-hjul/pickup/ram-1500',
    navLabel: 'Ram 1500',
  },
  {
    url: '/kompletta-hjul/pickup/nissan-navara',
    navLabel: 'Nissan Navara',
  },
  {
    url: '/kompletta-hjul/pickup/volkswagen-amarok',
    navLabel: 'Volkswagen Amarok',
  },
  {
    url: '/kompletta-hjul/pickup/gmc-sierra',
    navLabel: 'GMC Sierra',
  },
  {
    url: '/kompletta-hjul/pickup/ram-rampage',
    navLabel: 'Ram Rampage',
  },
  {
    url: '/kompletta-hjul/transportbil',
    navLabel: 'Transportbil',
  },
  {
    url: '/kompletta-hjul/transportbil/mercedes-sprinter',
    navLabel: 'Mercedes Sprinter',
  },
  {
    url: '/kompletta-hjul/transportbil/volkswagen-transporter',
    navLabel: 'Volkswagen Transporter',
  },
  {
    url: '/kompletta-hjul/transportbil/ford-transit-custom',
    navLabel: 'Ford Transit Custom',
  },
  {
    url: '/kompletta-hjul/transportbil/volkswagen-caddy',
    navLabel: 'Volkswagen Caddy',
  },
  {
    url: '/kompletta-hjul/transportbil/fiat-ducato',
    navLabel: 'Fiat Ducato',
  },
  {
    url: '/kompletta-hjul/transportbil/campervan',
    navLabel: 'Campervan',
  },
  {
    url: '/kompletta-hjul/transportbil/overlanding',
    navLabel: 'Overlanding',
  },
  {
    url: '/kompletta-hjul/personbil',
    navLabel: 'Personbil',
  },
  {
    url: '/kompletta-hjul/faq',
    navLabel: 'FAQ',
  },
]
